var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.attachments.length > 0
    ? _c("div", { staticClass: "file-attachments-preview" }, [
        _c(
          "div",
          { staticClass: "attachments-container" },
          _vm._l(_vm.attachments, function(attachment, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "attachment-item",
                class: { "is-image": _vm.isImage(attachment) }
              },
              [
                _vm.isImage(attachment)
                  ? _c(
                      "div",
                      {
                        staticClass: "image-thumbnail",
                        on: {
                          click: function($event) {
                            return _vm.previewImage(attachment)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "thumbnail-image",
                          attrs: {
                            src: _vm.getImageUrl(attachment),
                            alt: attachment.name
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "remove-button",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.removeAttachment(index)
                              }
                            }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/icons-2025/x-close.svg" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _c("div", { staticClass: "file-card" }, [
                      _c(
                        "div",
                        { staticClass: "file-icon" },
                        [
                          _c("InlineSvg", {
                            attrs: { src: _vm.getFileIcon(attachment) }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-info" }, [
                        _c("div", { staticClass: "file-name" }, [
                          _vm._v(_vm._s(attachment.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "file-type" }, [
                          _vm._v(_vm._s(_vm.getFileType(attachment)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "remove-button",
                          on: {
                            click: function($event) {
                              return _vm.removeAttachment(index)
                            }
                          }
                        },
                        [
                          _c("InlineSvg", {
                            attrs: { src: "/images/icons-2025/x-close.svg" }
                          })
                        ],
                        1
                      )
                    ])
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }